<div class="container py-4">
  <div *ngIf="viewState === 'form' || viewState === 'rejected'" class="row justify-content-center">
    <div class="col-auto">
      <div class="section-header mb-4 d-flex text-center justify-content-center gap-2" style="max-width: 520px;">
        <span class="material-symbols-outlined">person_add</span>
        <h1 class="h4">Solicita tu <strong class="fw-semibold text-colonial">registro de usuario</strong></h1>
      </div>
      <p class="text-muted mx-auto text-center" style="max-width: 520px;">Completa el siguiente formulario para solicitar acceso. Un administrador revisará tu solicitud.</p>
    </div>
  </div>

  <!-- Invited director: pre-authorized, only their personal info is confirmed -->
  <div *ngIf="viewState === 'invited'" class="row justify-content-center">
    <div class="col-12 col-md-10 col-xxl-6">
      <div class="section-header mb-4 d-flex text-center justify-content-center gap-2">
        <span class="material-symbols-outlined">how_to_reg</span>
        <h1 class="h4">Completa tu <strong class="fw-semibold text-colonial">registro</strong></h1>
      </div>

      <div class="card shadow-sm rounded-4 overflow-hidden">
        <div class="card-body p-4">
          <div class="alert alert-light border d-flex gap-2 align-items-start mb-4" role="alert">
            <span class="material-symbols-outlined text-colonial">verified_user</span>
            <div class="small">
              Has sido invitado como <strong>{{ inviteRoleLabel }}</strong> de
              <strong>{{ invite?.bankName }}</strong>. Solo necesitas confirmar tu información
              personal para activar el acceso.
            </div>
          </div>

          <form [formGroup]="inviteForm" (ngSubmit)="submitInvite()" class="row g-3">
            <div class="col-12">
              <label class="form-label" for="inviteEmailField">Correo electrónico</label>
              <input id="inviteEmailField" type="email" class="form-control" [value]="invite?.email" disabled />
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label" for="inviteFirstName">Nombre <span class="text-danger">*</span></label>
              <input id="inviteFirstName" type="text" class="form-control" formControlName="firstName" />
              <div *ngIf="inviteForm.get('firstName')?.invalid && inviteForm.get('firstName')?.touched"
                class="invalid mt-1">El nombre es requerido.</div>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label" for="inviteLastName">Apellido <span class="text-danger">*</span></label>
              <input id="inviteLastName" type="text" class="form-control" formControlName="lastName" />
              <div *ngIf="inviteForm.get('lastName')?.invalid && inviteForm.get('lastName')?.touched"
                class="invalid mt-1">El apellido es requerido.</div>
            </div>
            <div class="col-12 state-actions d-flex gap-2 justify-content-end mt-2">
              <button (click)="signOut()" class="btn btn-outline-secondary" type="button">
                Cancelar y volver
              </button>
              <button [disabled]="submitting" class="btn bg-colonial btn-secondary" type="submit">
                {{ submitting ? 'Completando...' : 'Completar registro' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Checking with the server what this applicant's situation is -->
  <div *ngIf="viewState === 'loading'" class="row justify-content-center">
    <div class="col-auto text-center py-5">
      <div class="spinner-border text-colonial" role="status"></div>
      <p class="text-muted mt-3 mb-0">Verificando el estado de tu solicitud...</p>
    </div>
  </div>

  <div *ngIf="viewState === 'pending'" class="row justify-content-center">
    <div class="col-12 col-md-10 col-xxl-6">
      <div class="card shadow-sm rounded-4 overflow-hidden text-center">
        <div class="card-body border-0 py-5">
          <span class="material-symbols-outlined text-colonial" style="font-size: 48px;">hourglass_top</span>
          <h2 class="h5 mt-3">Tu solicitud está pendiente de aprobación</h2>
          <p class="text-muted mx-auto" style="max-width: 440px;">
            <ng-container *ngIf="registration?.createdAt">
              La recibimos el {{ registration?.createdAt | date: 'dd/MM/yyyy' }}.
            </ng-container>
            Un administrador la revisará. Cuando sea aprobada podrás iniciar sesión con esta
            misma cuenta. No necesitas enviarla de nuevo.
          </p>
          <div class="state-actions d-flex gap-2 justify-content-center mt-3">
            <button (click)="recheck()" [disabled]="checking" class="btn bg-colonial btn-secondary" type="button">
              {{ checking ? 'Comprobando...' : 'Comprobar de nuevo' }}
            </button>
            <button (click)="signOut()" class="btn btn-outline-secondary" type="button">
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="viewState === 'deactivated'" class="row justify-content-center">
    <div class="col-12 col-md-10 col-xxl-6">
      <div class="card shadow-sm rounded-4 overflow-hidden text-center">
        <div class="card-body border-0 py-5">
          <span class="material-symbols-outlined text-colonial" style="font-size: 48px;">lock</span>
          <h2 class="h5 mt-3">Tu cuenta está desactivada</h2>
          <p class="text-muted mx-auto" style="max-width: 440px;">
            Tu registro fue aprobado, pero tu cuenta se encuentra desactivada.
            Contacta a tu supervisor para reactivarla.
          </p>
          <div class="state-actions d-flex gap-2 justify-content-center mt-3">
            <button (click)="recheck()" [disabled]="checking" class="btn bg-colonial btn-secondary" type="button">
              {{ checking ? 'Comprobando...' : 'Comprobar de nuevo' }}
            </button>
            <button (click)="signOut()" class="btn btn-outline-secondary" type="button">
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="viewState === 'rejected'" class="row justify-content-center mb-3">
    <div class="col-12 col-md-10 col-xxl-6">
      <div class="alert alert-warning border-0 shadow-sm mb-0">
        <div class="d-flex gap-2">
          <span class="material-symbols-outlined">error</span>
          <div>
            <strong>Tu solicitud fue rechazada.</strong>
            <div class="small mt-1">
              Motivo: {{ registration?.rejectionReason || 'No se indicó un motivo.' }}
            </div>
            <div class="small mt-1">
              Puedes corregir la información y enviar una nueva solicitud.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <form *ngIf="viewState === 'form' || viewState === 'rejected'" (ngSubmit)="submit()" [formGroup]="form" novalidate>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-xxl-6">
        <div class="card shadow-sm rounded-4 overflow-hidden">
          <div class="card-header bg-white py-3">
            <h3 class="h5 d-flex gap-2 mb-0 align-items-center">
              <span class="material-symbols-outlined text-colonial">counter_1</span>
              <span>Información básica</span>
            </h3>
          </div>
          <div class="card-body border-0">
            <div class="row g-3">
              <!-- Only claim the fields are locked when the account actually supplied them -->
              <div class="col-12" *ngIf="anyLockedFromB2C">
                <div class="alert alert-light border d-flex align-items-center gap-2 mb-1">
                  <span class="material-symbols-outlined text-colonial">badge</span>
                  <small class="text-muted">
                    Los datos que provienen de la cuenta con la que iniciaste sesión
                    no pueden modificarse aquí.
                  </small>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="form-group my-1">
                  <label>Nombre</label>
                  <input class="form-control" formControlName="firstName" sharedFormInput type="text"
                    [readonly]="lockedFromB2C.firstName" [class.bg-light]="lockedFromB2C.firstName" />
                  <div *ngIf="form.get('firstName')?.touched && form.get('firstName')?.invalid" class="invalid">Requerido</div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group my-1">
                  <label>Apellido</label>
                  <input class="form-control" formControlName="lastName" sharedFormInput type="text"
                    [readonly]="lockedFromB2C.lastName" [class.bg-light]="lockedFromB2C.lastName" />
                  <div *ngIf="form.get('lastName')?.touched && form.get('lastName')?.invalid" class="invalid">Requerido</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="form-group my-1">
                  <label>Correo electrónico</label>
                  <input class="form-control" formControlName="email" sharedFormInput type="email"
                    [readonly]="lockedFromB2C.email" [class.bg-light]="lockedFromB2C.email" />
                  <div *ngIf="form.get('email')?.touched && form.get('email')?.invalid" class="invalid">Ingrese un correo válido</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="form-group my-1">
                  <label>Documento de identidad</label>
                  <input class="form-control" formControlName="documentNumber" sharedFormInput type="text"
                    mask="000-0000000-0" [dropSpecialCharacters]="false" placeholder="000-0000000-0" inputmode="numeric" />
                  <div *ngIf="form.get('documentNumber')?.touched && form.get('documentNumber')?.hasError('required')"
                    class="invalid">Requerido</div>
                  <div *ngIf="form.get('documentNumber')?.touched && form.get('documentNumber')?.hasError('pattern')"
                    class="invalid">Formato inválido. Usa 000-0000000-0</div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="form-group my-1">
                  <label>Rol solicitado</label>
                  <input *ngIf="roleLocked" class="form-control bg-light" [value]="lockedRoleLabel" type="text" readonly />
                  <select *ngIf="!roleLocked" class="form-select" formControlName="requestedRole" sharedFormInput>
                    <option [ngValue]="null" disabled>Seleccione...</option>
                    <option *ngFor="let r of roles" [ngValue]="r.value">{{ r.label }}</option>
                  </select>
                  <div *ngIf="form.get('requestedRole')?.touched && form.get('requestedRole')?.invalid" class="invalid">Requerido</div>
                </div>
              </div>

              <ng-container *ngIf="!isSupervisor">
                <div class="col-12 col-md-4">
                  <div class="form-group my-1">
                    <label>Banco</label>
                    <select class="form-select" formControlName="bankId" sharedFormInput>
                      <option [ngValue]="null">Seleccione...</option>
                      <option *ngFor="let b of banks" [ngValue]="b.id">{{ b.name }}</option>
                    </select>
                    <div *ngIf="form.get('bankId')?.touched && form.get('bankId')?.invalid" class="invalid">Requerido</div>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="form-group my-1">
                    <label>Sucursal</label>
                    <select class="form-select" formControlName="branchId" sharedFormInput>
                      <option [ngValue]="null">Seleccione...</option>
                      <option *ngFor="let br of branches" [ngValue]="br.id">{{ br.name }}</option>
                    </select>
                    <div *ngIf="form.get('branchId')?.touched && form.get('branchId')?.invalid" class="invalid">Requerido</div>
                  </div>
                </div>
              </ng-container>

              <div class="col-12">
                <div class="form-group my-1">
                  <label>Comentarios (opcional)</label>
                  <textarea class="form-control" formControlName="notes" rows="2"
                    placeholder="Información adicional para quien revise tu solicitud"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="isSupervisor" class="card shadow-sm rounded-4 overflow-hidden mt-3">
          <div class="card-header bg-white py-3">
            <h3 class="h5 d-flex gap-2 mb-0 align-items-center">
              <span class="material-symbols-outlined text-colonial">counter_2</span>
              <span>Asignaciones</span>
            </h3>
          </div>
          <div class="card-body border-0">
            <p class="text-muted small mb-3">
              Indica los bancos y sucursales en los que trabajarás. Puedes agregar más de uno.
            </p>

            <div formArrayName="assignments">
              <!-- col-sm / col-sm-auto rather than a fixed 5/5/2 split: the card is narrow
                   at this breakpoint and a fixed column cannot hold the button -->
              <div *ngFor="let a of assignments.controls; let i = index" [formGroupName]="i" class="row g-2 align-items-end mb-2">
                <div class="col-12 col-sm">
                  <div class="form-group my-1">
                    <label>Banco</label>
                    <select class="form-select" formControlName="bankId" sharedFormInput>
                      <option [ngValue]="null">Seleccione...</option>
                      <option *ngFor="let b of banks" [ngValue]="b.id">{{ b.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-sm">
                  <div class="form-group my-1">
                    <label>Sucursal</label>
                    <select class="form-select" formControlName="branchId" sharedFormInput>
                      <option [ngValue]="null">Seleccione...</option>
                      <option *ngFor="let br of branchesFor(a)" [ngValue]="br.id">{{ br.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-sm-auto">
                  <button (click)="removeAssignment(i)" class="btn btn-outline-danger w-100 mb-1" type="button">
                    Quitar
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="!assignments.length" class="text-muted small fst-italic mb-3">
              Aún no has agregado ninguna asignación.
            </div>

            <button (click)="addAssignment()" class="btn btn-outline-colonial btn-sm" type="button">
              Agregar asignación
            </button>
          </div>
        </div>

        <div class="d-flex align-items-center my-4 justify-content-end">
          <button [disabled]="submitting || form.invalid" class="btn w-100 btn-lg btn-dark bg-colonial border" type="submit">
            Enviar solicitud
          </button>
        </div>
        <div class="text-center">
          <button (click)="cancel()" class="btn btn-link" type="button">Cancelar y volver</button>
        </div>
      </div>
    </div>
  </form>
</div>
